import { KeyboardEvent, useCallback } from 'react';
import './ToggleSwitch.scss';
import Text from '../Text/Text';

const ToggleSwitch = ({
  inputId,
  name,
  label,
  isChecked = false,
  onChange,
  disabled = false,
}: {
  inputId: string;
  isChecked: boolean;
  onChange: (v: unknown) => void;
  name?: string;
  label?: string;
  disabled?: boolean;
}) => {
  const handler = useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      if (disabled) return;

      if (e.key === 'Enter') {
        // @ts-expect-error check does exist i promise
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        onChange({ name: inputId, value: e.target.checked });
      }
    },
    [inputId, onChange, disabled],
  );

  return (
    <div className={`toggle-container${disabled ? ' disabled' : ''}`}>
      <div id={`${inputId}-container`} className="toggle-switch">
        <input
          data-testid={inputId}
          type="checkbox"
          name={name}
          className="toggle-switch-checkbox"
          id={inputId}
          checked={isChecked}
          onChange={e => onChange({ key: inputId, value: e.target.checked })}
          disabled={disabled}
          onKeyUp={handler}
          tabIndex={1}
        />
        <label
          id={`${inputId}-label`}
          className="toggle-switch-label"
          htmlFor={inputId}
          tabIndex={disabled ? -1 : 0}
        >
          <span
            className={
              disabled ? 'toggle-switch-inner toggle-switch-disabled' : 'toggle-switch-inner'
            }
          />
          <span
            className={
              disabled ? 'toggle-switch-switch toggle-switch-disabled' : 'toggle-switch-switch'
            }
          />
        </label>
      </div>
      {label && (
        <span className="body">
          <Text type="body">{label}</Text>
        </span>
      )}
    </div>
  );
};

export default ToggleSwitch;
